/* eslint-disable max-classes-per-file */
import { Expose, plainToInstance, Type } from 'class-transformer';
import { IsInt, IsOptional, Max, Min } from 'class-validator';

export class PaginatedRequestDto {
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @IsOptional()
  readonly page: number = 1;

  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(50)
  @IsOptional()
  readonly take: number = 12;

  get skip(): number {
    return (this.page - 1) * this.take;
  }
}

export class PaginatedResponseDto {
  @Expose()
  readonly page: number;

  @Expose()
  readonly take: number;

  @Expose()
  readonly totalItems: number;

  constructor(pageMetaDto: PaginatedResponseDto) {
    const properties = plainToInstance(PaginatedResponseDto, pageMetaDto, { excludeExtraneousValues: true });
    Object.assign(this, properties);
  }
}
